import { TenantResolverService } from '@/app/core/services/tenant-resolver/tenant-resolver';
import { UserService } from '@/app/core/services/user-service/user-service';
import { AuthService } from '@/app/features/pre-login/services/login-service/auth-service';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-authorized',
  imports: [],
  templateUrl: './not-authorized.html',
  styleUrl: './not-authorized.css',
})
export class NotAuthorized {
  constructor(
    private router: Router,
    private tenantResolver: TenantResolverService,
    private userService: UserService
  ) {}

  isReload: boolean = false;
  isAdmin: boolean = false;
  ngOnInit(): void {
    this.tenantResolver.getUserContext$().subscribe((context) => {
      if (context.userType === 'admin') {
        this.isAdmin = true;
      }
    });
    // const navEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
    // this.isReload = navEntry?.type === 'reload';

    // if (this.isReload) {
    //   this.router.navigate(['/auth/login']);
    // } else {
    //   this.router.navigate(['']);
    // }
  }
  goBack() {
    this.router.navigate(['']);
  }
  goToLogin() {
    this.userService.logout();
  }
}
